import { io, Socket } from 'socket.io-client';
import { getClerkToken } from '../lib/clerkToken';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL ?? 'http://localhost:3000';

let socket: Socket | null = null;

export async function connectSocket(): Promise<Socket> {
  if (socket?.connected) return socket;

  const token = await getClerkToken();

  if (!token) {
    throw new Error('Cannot connect socket: no auth token');
  }

  if (socket) {
    socket.disconnect();
    socket = null;
  }

  socket = io(SOCKET_URL, {
    auth: { token },
    transports: ['websocket'],
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
  });

  socket.on('connect_error', async (err) => {
    if (import.meta.env.DEV) console.warn('[socket] connect_error:', err.message);
    if (err.message?.includes('auth') || err.message?.includes('401')) {
      const fresh = await getClerkToken();
      if (fresh && socket) {
        (socket.auth as Record<string, string>).token = fresh;
        socket.connect();
      }
    }
  });

  socket.on('disconnect', (reason) => {
    if (import.meta.env.DEV) console.warn('[socket] disconnected:', reason);
  });

  return socket;
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = null;
}

export function getSocket(): Socket | null {
  return socket;
}

export function joinRequest(requestId: string) {
  socket?.emit('join-request', { requestId });
}

export function leaveRequest(requestId: string) {
  socket?.emit('leave-request', { requestId });
}

export function onRequestStatus(
  cb: (payload: { requestId: string; status: string }) => void,
): () => void {
  if (!socket) return () => {};
  socket.on('request-status', cb);
  return () => { socket?.off('request-status', cb); };
}
